import { locale } from "../locale"

/**
 * @param {Smartplug} sp 
 * @returns {string}
 */
function checkLoadAlarm(sp) {
    if (sp.LoadAlarm.Enabled && sp.LoadAlarm.Triggered)
        return locale.string({
            enGB: "Load alarm triggered",
            deDE: "Last außerhalb des erwarteten Intervalls",
            frFR: "Charge en dehors de l'intervalle prévu",
            svSE: "Belastning utanför förväntat intervall",
        })

    return ""
}

/**
 * @param {Smartplug} sp 
 * @returns {string}
 */
function checkOfflineAlarm(sp) {
    if (sp.OfflineAlarm && sp.OfflineAlarm.Enabled && sp.OfflineAlarm.Triggered)
        return locale.string({
            enGB: "Device offline",
            deDE: "Gerät offline",
            frFR: "Appareil hors ligne",
            svSE: "Enhet offline",
        })

    return ""
}

/**
 * @param {Smartplug} sp 
 * @returns {string}
 */
function checkPowerFailureAlarm(sp) {
    if (sp.PowerFailureAlarm.Enabled && sp.PowerFailureAlarm.Triggered)
        return locale.string({
            enGB: "Power failure",
            deDE: "Stromausfall",
            frFR: "Panne de courant",
            svSE: "Strömavbrott",
        })

    return ""
}

/**
 * @param {Smartplug} sp 
 * @returns {string}
 */
function checkTemperatureAlarm(sp) {
    if (sp.TemperatureRangeAlarm.Enabled && sp.TemperatureRangeAlarm.Triggered)
        return locale.string({
            enGB: "Temperature outside expected interval",
            deDE: "Temperatur außerhalb des erwarteten Intervalls",
            frFR: "Température en dehors de l'intervalle prévu",
            svSE: "Temperatur utanför förväntat intervall",
        })

    return ""
}

/**
 * @param {Smartplug} sp 
 * @returns {string[]}
 */
function getSmartplugWarnings(sp) {
    return [
        checkLoadAlarm(sp),
        checkOfflineAlarm(sp),
        checkPowerFailureAlarm(sp),
        checkTemperatureAlarm(sp),
    ].filter(text => text !== "")
}

export {
    getSmartplugWarnings
}

